const currentCourse = { value: 'CURRENT_COURSES', label: 'คอร์สที่เรียนอยู่' };
const expiredCourse = { value: 'EXPIRED_COURSES', label: 'คอร์สหมดอายุ' };

const sortByDate = [
  {
    value: 'LATEST',
    label: 'วันที่ซื้อคอร์ส (ใหม่→เก่า)',
  },
  { value: 'OLDEST', label: 'วันที่ซื้อคอร์ส (เก่า→ใหม่)' },
];
const sortByProgress = { value: 'PROGRESS', label: 'ความคืบหน้า' };
const sortByName = [
  {
    value: 'NAME_ASC',
    label: 'ชื่อคอร์ส (A→Z, ก→ฮ)',
  },
  { value: 'NAME_DESC', label: 'ชื่อคอร์ส (Z→A, ฮ→ก)' },
];

export const FILTER_LIST_WITHOUT_COURSE_FILTER = {
  courseFilter: { label: 'ประเภท', items: [] },
  sortFilter: { label: 'เรียงลำดับคอร์ส', items: [...sortByDate, sortByProgress, ...sortByName] },
};

export const FILTER_LIST_WITHOUT_PROGRESS = {
  courseFilter: { label: 'ประเภท', items: [currentCourse, expiredCourse] },
  sortFilter: { label: 'เรียงลำดับคอร์ส', items: [...sortByDate, ...sortByName] },
};

export const FILTER_LIST_DEFAULT = {
  courseFilter: { label: 'ประเภท', items: [currentCourse, expiredCourse] },
  sortFilter: { label: 'เรียงลำดับคอร์ส', items: [...sortByDate, sortByProgress, ...sortByName] },
};

export const COURSE_FILTER = {
  CURRENT_COURSES: 'CURRENT_COURSES',
  EXPIRED_COURSES: 'EXPIRED_COURSES',
};

export const SORT_FILTER = {
  LATEST: 'LATEST',
  OLDEST: 'OLDEST',
  PROGRESS: 'PROGRESS',
  NAME_ASC: 'NAME_ASC',
  NAME_DESC: 'NAME_DESC',
};
